import { FC } from 'react'
import Link from 'next/link'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import styles from './EncyclopediaNavigationMenu.module.scss'
import { NavigationMenuProps as Props } from './types'
import { ButtonArrow } from 'components/button/assets'
import Button from 'components/button/Button'
import { routes } from 'utils/routes'
import { Language } from 'types/language'

const EncyclopediaNavigationMenu: FC<Props> = ({ categories }) => {
  // I18n
  const { t } = useTranslation('home')

  return (
    <div className={classNames('container', styles['encyclopedia-navigation-menu'])}>
      <h2>{t('encyclopediaTitle', "Bolt's energie-encyclopedie")}</h2>

      <nav className={styles.menu}>
        {Object.keys(categories).map((category) => (
          <div key={category} className={styles['category-group']}>
            <h3>
              <Link href={categories[category].slug}>
                <a style={{ textDecorationColor: categories[category].color ?? 'unset' }}>{category}</a>
              </Link>
            </h3>

            <ul className={styles['sub-category-group']}>
              {categories[category].subCategories.map((subCat) => (
                <li key={subCat.title}>
                  <Link href={subCat.slug}>
                    <a className={styles.link}>
                      {subCat.title}
                      <ButtonArrow className={styles.arrow} />
                    </a>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>

      <Button link={routes(Language.DUTCH).encyclopedia} withArrow isFullWidthMobile isNotSubmit isInverse>
        {t('encyclopediaButton', 'Naar de encyclopedie')}
      </Button>
    </div>
  )
}

export default EncyclopediaNavigationMenu
